import { defineMessages, FormattedMessage } from 'react-intl';

import { INTL_PREFIX } from '@/messages/const';

export const intlPrefix = `${INTL_PREFIX.PAYMENT}.cembra`;

export const messages = defineMessages({
  title: {
    id: `${intlPrefix}.financeCalculator.title`,
    defaultMessage: 'Finance Calculator',
  },
  cembraBenefits: {
    id: `${intlPrefix}.financeCalculator.cembraBenefits`,
    defaultMessage:
      'CembraPay, a business unit of Cembra Money Bank AG, offers 0% financing. Your benefits:',
  },
  cembraBenefit1: {
    id: `${intlPrefix}.financeCalculator.cembraBenefit1`,
    defaultMessage: 'Payment in installments with 0% interest',
  },
  cembraBenefit2: {
    id: `${intlPrefix}.financeCalculator.cembraBenefit2`,
    defaultMessage: 'No deposit and no hidden costs',
  },
  cembraBenefit3: {
    id: `${intlPrefix}.financeCalculator.cembraBenefit3`,
    defaultMessage: 'Payment in installments up to 48 months possible',
  },
  cembraAdmissionCriteriaTitle: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaTitle`,
    defaultMessage: 'Admission criteria for a 0% financing with “CembraPay” :',
  },
  cembraAdmissionCriteriaItem1: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaItem1`,
    defaultMessage: 'Swiss citizenship or settlement permit B or C',
  },
  cembraAdmissionCriteriaItem2: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaItem2`,
    defaultMessage: 'Minimum age: 18 years',
  },
  cembraAdmissionCriteriaItem3: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaItem3`,
    defaultMessage: 'Maximum age: 85 years',
  },
  cembraAdmissionCriteriaItem4: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaItem4`,
    defaultMessage: 'Residence in Switzerland',
  },
  cembraAdmissionCriteriaItem5: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaItem5`,
    defaultMessage: 'Successful credit check',
  },
  cembraAdmissionCriteriaItem6: {
    id: `${intlPrefix}.financeCalculator.cembraAdmissionCriteriaItem6`,
    defaultMessage: 'No debt enforcement',
  },
  selectTermDuration: {
    id: `financeCalculator.selectTermDuration`,
    defaultMessage: 'Select a term duration',
  },
  clickHere: {
    id: 'financeCalculator.clickHere',
    defaultMessage: 'clicca qui',
  },
  currentSelection: {
    defaultMessage: 'Current selection :',
    id: `financeCalculator.currentSelection`,
  },
  months: {
    defaultMessage: 'Months',
    id: `financeCalculator.months`,
  },
  creditPlusAdvantagesText: {
    id: 'payment.creditPlus.financeCalculator.creditPlusAdvantagesText',
    defaultMessage:
      'Pay quick and simple in monthly installments with Creditplus Bank. Your advantages:',
  },
  easyOnlineApplicationProcess: {
    id: 'payment.creditPlus.easyOnlineApplicationProcess',
    defaultMessage: 'Easy online application process',
  },
  smoothOnlineIdentificationVideoIdent: {
    id: 'payment.creditPlus.financeCalculator.smoothOnlineIdentificationVideoIdent',
    defaultMessage: 'Smooth online identification through VideoIdent',
  },
  zeroApr: {
    id: 'payment.creditPlus.financeCalculator.zeroApr',
    defaultMessage: '0% APR',
  },
  noHiddenFees: {
    id: 'payment.creditPlus.financeCalculator.noHiddenFees',
    defaultMessage: 'No hidden fees',
  },
  creditPlusAdditionalText1: {
    id: 'payment.creditPlus.financeCalculator.additionalText1',
    defaultMessage:
      'Net loan amount = total loan amount, 0,00% APR, 0,00 % interest rate p.a.. Creditworthiness assumed.',
  },
  creditPlusAdditionalText2: {
    id: 'payment.creditPlus.financeCalculator.additionalText2',
    defaultMessage:
      'The information represent 6a Abs. 4 PAngV. Credit brokering is done exclusively for Creditplus Bank AG, Augustenstraße 7, 70178 Stuttgart',
  },
  creditPlusMinimumCriteria: {
    id: 'financeCalculator.creditPlusMinimumCriteria',
    defaultMessage:
      'Creditplus Bank requires that applicants meet these minimum criteria:',
  },
  creditPlusAge: {
    id: 'financeCalculator.creditPlusAge',
    defaultMessage: 'Age of at least 18 years;',
  },
  creditPlusIdentity: {
    id: 'financeCalculator.creditPlusIdentity',
    defaultMessage: 'Possession of a valid identity card or passport;',
  },
  creditPlusResidency: {
    id: 'financeCalculator.creditPlusResidency',
    defaultMessage: 'Residency in Germany; and',
  },
  creditPlusBankAccount: {
    id: 'financeCalculator.creditPlusBankAccount',
    defaultMessage: 'Ownership of a German bank account.',
  },
  creditPlusAdditionalConditions: {
    id: 'financeCalculator.creditPlusAdditionalConditions',
    defaultMessage: 'Additional Conditions:',
  },
  creditPlusNonEuCitizens: {
    id: 'financeCalculator.creditPlusNonEuCitizens',
    defaultMessage:
      'Non-EU citizens must hold valid residence and work permits, and the loan duration cannot exceed the validity of these permits.',
  },
  creditPlusSelfEmployed: {
    id: 'financeCalculator.creditPlusSelfEmployed',
    defaultMessage:
      'Self-employed individuals must demonstrate a minimum of 2 years of self-employment or satisfy additional requirements.',
  },
  creditPlusTraineesStudents: {
    id: 'financeCalculator.creditPlusTraineesStudents',
    defaultMessage:
      'Trainees can apply for loans up to EUR 5,000 and students can access loans up to EUR 1,000.',
  },
  creditPlusDisclaimer: {
    id: 'financeCalculator.creditPlusDisclaimer',
    defaultMessage:
      'Please note these represent the minimum requirements, and the decision regarding loan approval rests solely with Creditplus Bank, which will evaluate relevant criteria for each application.',
  },
});

export const CembraBenefit4 = ({ maxAmount }: { maxAmount: string }) => (
  <FormattedMessage
    defaultMessage='Maximum financing limit: {maxAmount}'
    id={`${intlPrefix}.financeCalculator.cembraBenefit4`}
    values={{
      maxAmount: maxAmount,
    }}
  />
);
export const CembraBenefit5 = ({ maxAmount }: { maxAmount: string }) => (
  <FormattedMessage
    defaultMessage='For financing requests above {maxAmount}, please contact us'
    id={`${intlPrefix}.financeCalculator.cembraBenefit5`}
    values={{
      maxAmount: maxAmount,
    }}
  />
);
